// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../model/types.tsx';
import { completeTask } from '../complete-task/complete-task.tsx';
import { continueToNextTask } from '../continue-to-next-task/continue-to-next-task.tsx';

export const completeTaskAndContinue =
	(id: string): Action<State> =>
	({ dispatch }) => {
		dispatch(completeTask(id));
		dispatch(continueToNextTask());
	};
